export default {
    list: 'product/list',
    add: 'product/add',
    monthGp: 'product/monthGp',
    details: 'product/details',
    customerList: 'product/customerList',
    pricingForCustomer: 'product/pricingForCustomer'
};